// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/Figure/Figure.less
// module id = 203
// module chunks = 2